<template>
  <div class="container-fluid mt-5">
    <card>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3 class="mb-0">
          {{ $t("ESTABLISHMENT_INTERNAL_ORDERS.EDIT_ESTABLISHMENT_INTERNAL_ORDER") }}
        </h3>
        <base-button type="secondary" @click="goBack">
          {{ $t("COMMON.RETURN_TO_LIST") }}
        </base-button>
      </div>
      <establishment-internal-order-form
        :orderModel="order"
        :loading="loading"
        :submitLabel="$t('COMMON.SAVE')"
        @submit="submit"
      />
    </card>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import defaultOrder from "./defaultEstablishmentInternalOrder";
import EstablishmentInternalOrderForm from "./partials/EstablishmentInternalOrderForm.vue";

export default {
  name: "EditEstablishmentInternalOrderPage",
  components: { EstablishmentInternalOrderForm },
  data() {
    return {
      order: cloneDeep(defaultOrder),
      loading: false,
    };
  },
  created() {
    this.getOrder();
  },
  methods: {
    async getOrder() {
      this.loading = true;
      try {
        await this.$store.dispatch("establishmentInternalOrders/get", {
          id: this.$route.params.id,
        });
        this.order =
          this.$store.getters["establishmentInternalOrders/order"] || cloneDeep(defaultOrder);
      } finally {
        this.loading = false;
      }
    },
    async submit(payload) {
      this.loading = true;
      try {
        await this.$store.dispatch("establishmentInternalOrders/update", { data: payload });
        const order = this.$store.getters["establishmentInternalOrders/order"];
        this.$notify({
          type: "success",
          message: this.$t(
            "ESTABLISHMENT_INTERNAL_ORDERS.ESTABLISHMENT_INTERNAL_ORDER_UPDATED"
          ),
        });
        this.goToView(order.id);
      } finally {
        this.loading = false;
      }
    },
    goToView(id) {
      this.$router.push({ name: "View EstablishmentInternalOrder", params: { id } });
    },
    goBack() {
      this.$router.push({ name: "List EstablishmentInternalOrders" });
    },
  },
};
</script>
